class QuestiaUIUtils {

    static computeAndAddHeightForErrorMessage = (idInput, idSpan, activ) => {
        var spanLoadingTag = document.getElementById(idSpan);
        var errorHeight = 0;
        if(spanLoadingTag != null) {
            errorHeight = spanLoadingTag.scrollHeight;
        }

        if (activ) {
            document.getElementById(idInput).style.marginBottom = "0px";
        }
        else{
            document.getElementById(idInput).style.marginBottom = (errorHeight + 5) + "px";
        }
    };

    static addBottomForErrorMessage = (idSpan, activ) => {
        var spanLoadingTag = document.getElementById(idSpan);
        var errorHeight = 0;
        if(spanLoadingTag != null) {
            errorHeight = spanLoadingTag.scrollHeight;
        }

        if (activ) {
            document.getElementById(idSpan).style.bottom = "0px";
        }
        else{
            document.getElementById(idSpan).style.bottom = (-errorHeight - 5) + "px";
        }
    };

    // Phone number is changed to the format saved in database
    static transformPhoneNumberForDatabase = (phoneNumber) => {
        var str = phoneNumber;
        var valueRet = "";
        var i;

        if (typeof phoneNumber === "undefined" || phoneNumber === "" || phoneNumber === null) {
            return "";
        }

        if (str[0] == '+') {
            valueRet += str[0];
        }

        for (i = 0; i < str.length; i++) {
            if (str[i] >= '0' && str[i] <= '9') {
                valueRet += str[i];
            }
        }

        return valueRet;
    };

    // Phone number is changed to the UI format
    // Unused for now because "InputMask" does that instead
    static transformPhoneNumberForUI = (phoneNumber) => {
        var str = phoneNumber;
        var valueRet = "";
        var mask = window.questiaSpecificWebsiteConfig.PHONE_MASK_PLACEHOLDER;
        var ct = 0;
        var i;

        for (i = 0; i < mask.length; i++) {
            if (mask[i] == "_") {
                valueRet += str[ct];
                ct++;
            } else {
                if (mask[i] === str[ct]) {
                    valueRet += mask[i];
                    ct++;
                } else {
                    valueRet += mask[i];
                }
            }
        }

        return valueRet;
    };
}
export default QuestiaUIUtils;